/** CanvasModulate strict validators: the `color` property. */
// The base chain: registration happens on import, so a test that loads only this
// slice resolves an inherited key only through this line.
import '../../base/node2d/linterParser.js';
import { validatorRegistry } from '../../../linter/ValidatorRegistry.js';
import { v } from '../../../linter/validators/index.js';
validatorRegistry.registerAll('CanvasModulate', {
    color: v.color('color'),
});
//# sourceMappingURL=linterParser.js.map